<template>
    <div class="phone-number">
        <input type="tel" :required="config.required"
               class="tw-w-full tw-border-0 tw-border-b tw-bg-transparent focus:tw-outline-none focus:tw-ring-0"
               :style="inputStyles"
               ref="input"
               :readonly="readonly"
               :value="value"
               @keyup="onAnswerInput" @paste="onAnswerInput">
    </div>
</template>

<script>
export default {
    name: 'QuestionPhoneNumber',
    props: {
        value: {
            type: String,
            default: ''
        },
        inputStyles: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    watch: {
        value: {
            handler(value) {
                this.answer(value);
            },
            immediate: true
        },
    },
    methods: {
        onAnswerInput(event) {
            this.answer(event.target.value);
        },
        answer(value) {
            this.$emit('answer', {
                value: value,
                valid: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/.test(value)
            });
        }
    },
}
</script>
